import { buildUrl, filterEmpty, getSearchParam } from ".";
import { getLangMap } from "@/utils/getLangMap.ts";
import { cleanHash } from "./sendLog1";
import { isTrTabLanguageHost, resolveCountryCodeFromLanguageInput } from "@/utils/trTabLanguageResolver";

const FIRST_PV_SESSION_KEY = "pageAccessFirstPvLogged";

/**
 * 说明：
 * - `event_id=1` 仅表示当前会话的首次 PV
 * - 其余页面访问统一打 `event_id=0`
 * 这样日志侧既能区分首次 PV，也不会遗漏首次进入非首页的场景。
 */
export function resolveFirstPvEventId() {
  const hasLoggedFirstPv = SessionStorage.getItem(FIRST_PV_SESSION_KEY) === "1";
  if (hasLoggedFirstPv) {
    return 0;
  }
  SessionStorage.setItem(FIRST_PV_SESSION_KEY, "1");
  return 1;
}

/**
 * 说明：
 * 日志侧需要支持 `渠道号` 与 `渠道号 + 国家` 查询。
 * 这里统一把 query 中显式国家、以及 `en-gb / pt-br / zh-tw` 这类语言 tag 里的国家拆出来。
 */
export function resolveLogCountryCode() {
  const lanParam = getSearchParam("lan");
  const conParam = getSearchParam("con");
  const channel = getSearchParam("channel") || "";
  const { hostName, domain } = useHostName();
  const { subdomain } = useSubdomain();

  if (isTrTabLanguageHost({ hostName, domain, subdomain, channel })) {
    return resolveCountryCodeFromLanguageInput({ lan: lanParam, con: conParam });
  }

  return resolveCountryCodeFromLanguageInput({ lan: lanParam, con: conParam });
}

export default function sendLog2({ action }: any) {
  const channel = getSearchParam("channel");
  const device = getSearchParam("device") || "default";
  const { hostName } = useHostName();
  const allowedDomains = [...domainMap["wg"], ...domainMap["miwg"]];
  const countryCode = resolveLogCountryCode();
  const params = filterEmpty({
    host: window.location.hostname,
    action: action,
    ch: channel,
    lan: getLangMap(),
    con: countryCode,
    page: cleanHash(window.location.hash.substring(2)),
    event_id: resolveFirstPvEventId(),
    ...(allowedDomains.includes(hostName) && { device }), // 仅在条件满足时添加 device
  });
  const url = buildUrl(import.meta.env.VITE_LOG_URL2, params);
  fetch(url, { method: "GET" });
}
